export default function modal() {
  // -----------------------------------------------------
  // モーダル/ポップアップ
  // 無制限
  // -----------------------------------------------------

  var ModalMain = document.querySelector(".modal_main")
  var BodyMain = document.getElementsByTagName("main")
  var mask = document.getElementById("mask")
  var mask_fix = document.getElementById("mask_fix")
  var target = document.getElementsByClassName("target")
  if (target) {
    //   //for分で要素数分ループ処理
    for (var i = 0; i < target.length; i++) {
      //クリックイベントを追加
      target[i].addEventListener(
        "click",
        function (event) {
          // winの切り分け
          var scrollElm = (function () {
            if ("scrollingElement" in document) return document.scrollingElement
            if (navigator.userAgent.indexOf("WebKit") != -1) return document.body
            return document.documentElement
          })()

          // スクロール値の取得
          var scrollTop = scrollElm.scrollTop

          // モーダルボタンの上にspanとかが乗ってると反応しないので注意！
          // おいた場合は    pointer-events: none;　で動作を制御
          // 開くモーダルのID生成
          var active = "m_open_search_modal"

          // -----------------------------------------------------
          // 開くモーダルを取得
          // -----------------------------------------------------
          var activeitem = document.getElementById(active)

          document.body.style.position = "fixed"
          BodyMain[0].style.position = "relative"
          BodyMain[0].style.top = "-" + scrollTop + "px"

          // -----------------------------------------------------
          // モーダル表示
          // -----------------------------------------------------
          if (active != "_modal") {
            activeitem.classList.toggle("hidden")
          }
          if (document.getElementById("mask")) {
            mask.classList.toggle("hidden")
          }
          if (document.getElementById("mask_fix")) {
            mask_fix.classList.toggle("hidden")
          }
          ModalMain.classList.toggle("fixed")
          window.scrollTo(0, scrollTop)

          // iosスクロールさせない
          document.body.style.overflow = "hidden"
          document.documentElement.style.overflow = "hidden"

          // -----------------------------------------------------
          //マスクエリアタッチで解除
          // -----------------------------------------------------
          if (document.getElementById("mask_fix")) {
            mask_fix.addEventListener("click", function () {
              document.body.style.position = "relative"
              activeitem.classList.add("hidden")
              mask_fix.classList.add("hidden")
              ModalMain.classList.remove("fixed")
              window.scrollTo(0, scrollTop)
              BodyMain[0].style.top = "0px"

              // iosスクロールを戻す
              document.body.style.overflow = "auto"
              document.documentElement.style.overflow = "auto"

              // var bghidden = function(){
              // 	mask.style.display = 'none'
              // 	}
              // bghidden(bghidden, 1000)
              resizeTop()
            })
          }

          // -----------------------------------------------------
          // キャンセルボタンタッチで解除
          // -----------------------------------------------------
          if (activeitem) {
            var cancel_button = activeitem.getElementsByClassName("modal_cancel")

            if (cancel_button[0]) {
              
              cancel_button[0].addEventListener("click", function () {
                document.body.style.position = "relative"
                activeitem.classList.add("hidden")
                if (document.getElementById("mask")) {
                  mask.classList.add("hidden")
                }
                if (document.getElementById("mask_fix")) {
                  mask_fix.classList.add("hidden")
                }
                ModalMain.classList.remove("fixed")
                window.scrollTo(0, scrollTop)

                BodyMain[0].style.top = "0px"

                // iosスクロールを戻す
                document.body.style.overflow = "auto"
                document.documentElement.style.overflow = "auto"

                resizeTop()
              })              
            }           
          }
        },
        false
      )
    }
  }
}

function resizeTop() {
  const nouHead3 = document.getElementById("now_head")

  // search_openクラスがある場合は高さ調整
  var isSearchOpen = Object.values(nouHead2.classList).includes('search_open');

  if (nouHead3 && isSearchOpen) {
    var H = nouHead3.clientHeight

    if (window.innerWidth < 750) {
      document.getElementById("js_main").style.top = H + "px"
    } else {
      document.getElementById("js_main").style.top = "52px"
    }
  }
  window.onresize = resizeWindow
}
